import Step2Zaglavlje from './Step2Zaglavlje';
import Step3Debljine from './Step3Debljine';
import Step4KarakteristikeDopa from "./Step4KarakteristikeDopa";

export const STEP_COMPONENTS = {
    zaglavlje: Step2Zaglavlje,
    debljine: Step3Debljine,
    karakteristike: Step4KarakteristikeDopa
};